// import validations
import validate from './validators'

// export validations for use in other applications
export default validate
